// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Lf_7w9LJpBZ7amgHcZ8A","contentWrapper":"_FGMdlEl4ZukSBoijezd"};